import { render, staticRenderFns } from "./Digital_cultural_legacy.vue?vue&type=template&id=0cd66a88&scoped=true&"
import script from "./Digital_cultural_legacy.vue?vue&type=script&lang=js&"
export * from "./Digital_cultural_legacy.vue?vue&type=script&lang=js&"
import style0 from "./Digital_cultural_legacy.vue?vue&type=style&index=0&id=0cd66a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd66a88",
  null
  
)

export default component.exports